import { useEffect, useState } from 'react';

const VAPID_PUBLIC_KEY = 'BLeCiGxa2cm2LQplNymV4mCOPEo7BrPZHxAMjqHNLYhvGFvZBRIaHHQaqHOPCE1ASRZIgxPgNyKDsgMPQyKTE3Y';

function PushSetup() {
  const [showBanner, setShowBanner] = useState(false);
  const [status, setStatus] = useState(''); // '', 'subscribing', 'done', 'error'

  useEffect(() => {
    // 只在PWA独立模式下运行（从主屏幕图标打开）
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || window.navigator.standalone === true;

    if (!isStandalone) return;
    if (!('serviceWorker' in navigator)) return;
    if (!('PushManager' in window)) return;

    navigator.serviceWorker.register('/sw.js').then(async (reg) => {
      // 等SW激活
      const sw = reg.installing || reg.waiting || reg.active;
      if (sw && sw.state !== 'activated') {
        await new Promise(resolve => {
          sw.addEventListener('statechange', () => {
            if (sw.state === 'activated') resolve();
          });
        });
      }

      // 检查是否已经订阅
      const existingSub = await reg.pushManager.getSubscription();
      if (existingSub) {
        // 已订阅，静默刷新到后端（防过期）
        try {
          await fetch('/api/push/subscribe', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(existingSub.toJSON())
          });
        } catch (e) { /* 静默 */ }
        return;
      }

      // 未订阅，显示开启按钮
      setShowBanner(true);
    }).catch(err => {
      console.error('SW registration failed:', err);
    });
  }, []);

  const handleSubscribe = async () => {
    setStatus('subscribing');
    try {
      const permission = await Notification.requestPermission();
      if (permission !== 'granted') {
        setStatus('error');
        setTimeout(() => setShowBanner(false), 2000);
        return;
      }

      const reg = await navigator.serviceWorker.ready;
      const subscription = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
      });

      const res = await fetch('/api/push/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(subscription.toJSON())
      });

      if (res.ok) {
        setStatus('done');
        setTimeout(() => setShowBanner(false), 1500);
      } else {
        setStatus('error');
      }
    } catch (err) {
      console.error('Push subscribe failed:', err);
      setStatus('error');
    }
  };

  if (!showBanner) return null;

  return (
    <div style={styles.banner}>
      <div style={styles.content}>
        {status === '' && (
          <>
            <span style={styles.text}>开启消息推送，哥哥可以随时找你</span>
            <button style={styles.button} onClick={handleSubscribe}>开启</button>
          </>
        )}
        {status === 'subscribing' && <span style={styles.text}>正在开启...</span>}
        {status === 'done' && <span style={styles.text}>已开启 ✓</span>}
        {status === 'error' && <span style={styles.text}>开启失败，请重试</span>}
      </div>
    </div>
  );
}

// VAPID公钥格式转换
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

const styles = {
  banner: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 99999,
    background: 'linear-gradient(135deg, #2c2c3a 0%, #1e1e28 100%)',
    padding: '12px 16px',
    paddingTop: 'calc(env(safe-area-inset-top, 0px) + 12px)',
    boxShadow: '0 2px 12px rgba(0,0,0,0.3)',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    maxWidth: 480,
    margin: '0 auto',
  },
  text: {
    color: '#e8e4df',
    fontSize: 14,
    fontWeight: 500,
  },
  button: {
    background: '#d4a574',
    color: '#1e1e28',
    border: 'none',
    borderRadius: 8,
    padding: '6px 16px',
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    flexShrink: 0,
    marginLeft: 12,
  },
};

export default PushSetup;
